import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getNotifications,
  markAllNotificationsRead,
  markNotificationRead,
} from "app/services/notification/notificationService";
import { BASE_URL } from "static/constants";

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Notifications"],
  endpoints: ({ query, mutation }) => ({
    getNotifications: query({
      queryFn: async ({ page = 1, limit = 20, userId } = {}) => {
        try {
          const data = await getNotifications({ page, limit, userId });
          return {
            data: { ...data, hasMore: data.notifications.length === limit },
          };
        } catch (error) {
          return { error };
        }
      },
      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) =>
        currentArg?.page !== previousArg?.page,
      merge: (currentCache, newResponse, { arg }) => {
        if (arg.page === 0) return newResponse;
        const incomingById = new Map(
          newResponse.notifications.map((n) => [n.id, n])
        );
        const existingIds = new Set(
          currentCache.notifications.map((n) => n.id)
        );
        return {
          ...newResponse,
          notifications: [
            ...currentCache.notifications.map(
              (n) => incomingById.get(n.id) ?? n
            ),
            ...newResponse.notifications.filter((n) => !existingIds.has(n.id)),
          ],
        };
      },
      providesTags: ["Notifications"],
    }),
    markAllAsRead: mutation({
      queryFn: async () => {
        try {
          const data = await markAllNotificationsRead();
          return { data };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ["Notifications"],
    }),
    markAsRead: mutation({
      queryFn: async (id) => {
        try {
          const data = await markNotificationRead(id);
          return { data };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAllAsReadMutation,
  useMarkAsReadMutation,
} = notificationApi;
